import React from "react";

class ModalEnviarConfirmacion extends React.Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
    this.state = {
      enviando: false // Estado para controlar el loading
    };
  }

  componentDidMount() {
    if (this.props.open) {
      this.abrirModal();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open !== prevProps.open) {
      if (this.props.open) {
        this.abrirModal();
      } else {
        this.cerrarModal();
      }
    }
  }

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  };

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
      this.setState({ enviando: false }); // Reset del estado
      if (this.props.onClose) this.props.onClose();
    }
  };

  handleConfirm = async () => {
    if (this.props.onConfirm) {
      this.setState({ enviando: true });
      
      try {
        // Esperar a que se complete la operación
        await this.props.onConfirm();
        // Solo cerrar si la operación fue exitosa
        this.cerrarModal();
      } catch (error) {
        // Si hay error, mantener el modal abierto
        this.setState({ enviando: false });
        console.error('Error al enviar notificación:', error);
      }
    }
  };

  render() {
    const { open } = this.props;
    const { enviando } = this.state;

    if (!open) return null;

    return (
      <div className="component-modal">
        <dialog
          className="modal"
          ref={this.dialogRef}
          id="modal-enviar-notificacion"
        >
          <div className="modal-content">
            <div className="modal-body">
              <h3 className="title">¿Enviar notificación?</h3>
              <p className="msg">
                {enviando 
                  ? "Enviando notificación, por favor espere..."
                  : "Está enviando una notificación, confirme para finalizar el proceso."
                }
              </p>
            </div>

            <div className="modal-footer">
              <button
                className="btn-medium btn-base-outline"
                type="button"
                onClick={this.cerrarModal}
                disabled={enviando} // Deshabilitar mientras se envía
              >
                Cancelar
              </button>
              <button
                className="btn-medium btn-success"
                type="button"
                onClick={this.handleConfirm}
                disabled={enviando} // Deshabilitar mientras se envía
              >
                {enviando ? "Enviando..." : "Enviar"}
              </button>
            </div>
          </div>
        </dialog>
      </div>
    );
  }
}

export default ModalEnviarConfirmacion;